import api from '../../api/index';
import config from '../../../static/config.json';


const actions = {
  // getData({ rootState, commit },opt) { //ExhibitionId
  //   // console.log(opt,id,'inMemberId')
  //   return new Promise((resolve, reject) => {
  //     let url=`${config.https.api}/api/v1/product/getuserpagedshortforexhibition?ExhibitionId=${opt.exhibitionId}`
  //     if(opt.category.length){
  //       opt.category.forEach(el => {
  //         url+=`&Category=${el}`
  //       });
  //     }
  //     if(opt.region.length){
  //       opt.region.forEach(el => {
  //         url+=`&Region=${el}`
  //       });
  //     }
  //     url+=`&pageIndex=${opt.pageIndex}&pageSize=${opt.pageSize}`;
  //     // console.log(url,opt,rootState.header,'getdata');
  //     // resolve(false);
  //     api.get(url,rootState.header).then(data => {
  //       resolve(data.data);
  //     }).catch((err) => {
  //       resolve('err')
  //     });
  //   });
  // },
  delEnquiryNew({ rootState }, id) { // 删除询盘（新）
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v3/exhibitornewenquiry?id=${id}`,rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
  submitFeedBack({ rootState }, opt) { // 提交反馈
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v3/feedback`, opt, rootState.header)
      .then(({
        data
      }) => {
        console.log(data,'反馈')
        if (data) {
          resolve(data);
        }
      });
    }).catch(err => {
      console.log(err);
    })
  },
  patchUser({ rootState }, opt) { // 修改用户部分信息
    return new Promise((resolve, reject) => {
      api.patch(`${config.https.api}/api/v1/member?id=${opt.id}`, opt.body, rootState.header)
      .then(({
        data
      }) => {
        resolve(data);
      });
    }).catch(err => {
      console.log(err);
    })
  },
  patchUserCategory({ rootState }, opt) { // 修改用户部分信息类别
    return new Promise((resolve, reject) => {
      api.patch(`${config.https.api}/api/v1/exhibitioninmember?id=${opt.id}`, opt.body, rootState.header)
      .then(({
        data
      }) => {
        resolve(data);
      });
    }).catch(err => {
      console.log(err);
    })
  },
  putPhone({ rootState }, opt) { // 修改用户手机
    return new Promise((resolve, reject) => {
      api.put(`${config.https.api}/api/v3/mmeberv3/update/phonenumber`, opt, rootState.header)
      .then(({
        data
      }) => {
        resolve(data);
      });
    }).catch(err => {
      console.log(err);
    })
  },
  putEmail({ rootState }, opt) { // 修改用户邮箱
    return new Promise((resolve, reject) => {
      api.put(`${config.https.api}/api/v3/mmeberv3/update/email`, opt, rootState.header)
      .then(({
        data
      }) => {
        resolve(data);
      });
    }).catch(err => {
      console.log(err);
    })
  },
  // 发送短信验证码
  sendCode({rootState}, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/sms/verificationcode`, opt).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      }).catch(err => {
        resolve(false);
        console.log(err)
      });
    });
  },
  // 发送邮箱验证码
  sendEamilCode({rootState}, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/verificationcode/email?email=${opt.email}`).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      }).catch(err => {
        resolve(false);
        console.log(err)
      });
    });
  },

  // 校验短信验证码
  validateCode({rootState}, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/verificationcode/valid?key=${opt.key}&code=${opt.code}`).then(data => {
        console.log(data);
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(data.data);
        }
      }).catch(err => {
        resolve(false);
        console.log(err)
      });
    });
  },

  // 注册用户
  regUser({rootState}, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v3/mmeberv3/reg/visitor`, opt, rootState.header).then(data => {
        console.log(data,'注册用户');
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(data.data);
        }
      }).catch(err => {
        resolve(false);
        console.log(err)
      });
    });
  },

  //删除供需
	delSupply({rootState},id){
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v3/supplydemand?id=${id}`,  rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  //删除讨论
	delTalk({rootState},id){
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v3/talk?id=${id}`,  rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  // 阅读消息
  msgRead({ rootState }, opt) { 
    return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v3/notificationmessage/read?messageId=${opt.messageId}&receiverId=${opt.receiverId}`,opt,rootState.header)
				.then(res=>{
					if(res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  addHello({ rootState }, opt) { 
    return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibitorsayhello`,opt,rootState.header)
				.then(res=>{
					if(res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  //展商预约参观
  exVisitor({ rootState }, opt) {
    return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v3/mmeberv3/exhibitorvisitor`,opt,rootState.header)
				.then(res=>{
					if(res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  // 打招呼类别已读
  addHelloRead({ rootState }, opt) { 
    return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibitorsayhello/click?`,opt,rootState.header)
				.then(res=>{
					if(res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  //删除讨论
	delSayHello({rootState},id){
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v1/exhibitorsayhello?id=${id}`,  rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
 
  // 回复打招呼
  putSayHello({rootState},opt){
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/api/v1/exhibitorsayhello/reply`,opt, rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
   // 回复打招呼
   putSayHello2({rootState},opt){
		return new Promise((resolve, reject) => {
			api.patch(`${config.https.api}/api/v1/exhibitorsayhello?id=${opt.id}`, opt.req, rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  //删除预约洽谈
	delTopice({rootState},id){
		return new Promise((resolve, reject) => {
			api.delete(`${config.https.api}/api/v3/exhibitorappointment?id=${id}`,  rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
  //编辑预约洽谈
	editTopice({rootState},body){
		return new Promise((resolve, reject) => {
			api.patch(`${config.https.api}/api/v3/exhibitorappointment?id=${body.id}`,body.opt, rootState.header)
				.then(res=>{
					if(res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
  },
}
export default {
  namespaced: true,
  actions,
} 